module.exports = __webpack_public_path__ + "img/icon-dropdown-black.147f3932.svg";